import { STRIPE_PROXY_URL } from '../config/billing';

const API = STRIPE_PROXY_URL;

const post = async (path: string, body: Record<string, unknown>) => {
  const res = await fetch(`${API}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
};

const get = async (path: string, params: Record<string, string>) => {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${API}/${path}?${qs}`);
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
};

const del = async (path: string, body: Record<string, unknown>) => {
  const res = await fetch(`${API}/${path}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error((await res.json()).error || res.statusText);
  return res.json();
};

export const stripeApi = {
  // Customer management
  createCustomer: (email: string, name: string, metadata?: Record<string, string>) =>
    post('customers', { email, name, metadata }),

  // Setup intents
  createSetupIntent: (customerId: string) =>
    post('setup-intent', { customer_id: customerId }),

  // Payment methods
  listPaymentMethods: (customerId: string) =>
    get('payment-methods', { customer_id: customerId }),
  detachPaymentMethod: (paymentMethodId: string) =>
    del('payment-methods', { payment_method_id: paymentMethodId }),

  // Subscription management (new multi-item endpoints)
  createSubscription: (
    customerId: string,
    priceIds: Array<{ price: string; quantity: number }>,
    metadata?: Record<string, string>
  ) =>
    post('subscriptions/create', { customer_id: customerId, price_ids: priceIds, metadata }),

  updateSubscription: (subscriptionId: string, items: Array<{ id: string; quantity: number }>) =>
    post('subscriptions/update', { subscription_id: subscriptionId, items }),

  cancelSubscription: (subscriptionId: string) =>
    post('subscriptions/cancel', { subscription_id: subscriptionId }),

  getSubscriptionDetail: (subscriptionId: string) =>
    get('subscriptions/detail', { subscription_id: subscriptionId }),

  // Legacy endpoints
  listSubscriptions: (customerId: string) =>
    get('subscriptions', { customer_id: customerId }),

  // Invoices
  listInvoices: (customerId: string) =>
    get('invoices', { customer_id: customerId }),

  // Billing portal
  createBillingPortal: (customerId: string, returnUrl: string) =>
    post('billing-portal', { customer_id: customerId, return_url: returnUrl }),
};
